<style>
    .activity-log-form {
        font-size: .9rem;
    }
    .activity-log-form .card-header h4,
    .activity-log-form .card.card-success .card-header h4 {
        height: 60px;
        font-weight: 300;
        font-size: 20pt;
        letter-spacing: 2px;
        padding: auto;
    }

    #main_content .activity-log-form select,
    #main_content .activity-log-form input[type=text],
    #main_content .activity-log-form input[type=date],
    #main_content .activity-log-form textarea {
        font-size: 12px !important;
        height: 40px !important;
        padding-left: 1em;
    }
    #main_content .activity-log-form textarea {
        height: inherit !important;
    }
    #main_content .activity-log-form p {
        font-weight: bold;
        color: #223264;
        font-size: 15px;
        margin: 7px 0 0 0;
    }
</style>

<template>
    <BModal 
        ref="createEditModal" 
        size="lg" 
        hide-footer 
        hide-header
        header-class="success"
        v-model="showModal"
        class="activity-log-form"
        @hidden="clearForm"
    >
        <div class="card-deck"> 
            <div class="card card-success mb-6"> 
            <div class="card-header bg-success text-center"> 
                <div class="pull-right">
                    <button type="button" aria-label="Close" class="close" v-on:click="hide()">×</button>
                </div>
                <h4 class="my-0">
                {{title}} TA Activity
                </h4> 
            </div> 
            <div class="card-body">
                <form action="consultants/activity-log/store" method="POST" id="activity-log-form">
                <p>Record TA Activity for this program.</p>
                <div class="row">
                    <div class="col">
                    <div class="form-group">
                        <label for="date">Date</label>
                        <bootstrap-date-picker 
                            v-model="date" 
                            class="form-control"
                            placeholder="mm/dd/yyyy" 
                        />
                        <error-message v-if="hasError('date')" :errors="error.date"></error-message>
                    </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label for="activity">Activity Type</label>
                            <select class="form-control" id="activity_log_type_id" name="activity_log_type_id" v-model="type" v-show="typeOptions.length > 0">
                                <option value="" selected>Select Type</option>
                                <option v-for="aType in typeOptions" :key="aType.id" :value="aType.id">{{aType.name}}</option>
                            </select>
                            <div  v-show="typeOptions.length == 0">Loading types...</div>
                            <error-message v-if="hasError('activity_log_type_id')" :errors="error.activity_log_type_id"></error-message>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                    <div class="form-group">
                        <label for="hours">Please enter your time spent:</label>
                        <div class="row">
                            <div class="col-6">
                                <select class="form-control" name="hours" id="hours" v-model="hours">
                                    <option value="" selected>Hours</option>
                                    <option value="0">0 Hours</option>
                                    <option value="1">1 Hour</option>
                                    <option value="2">2 Hours</option>
                                    <option value="3">3 Hours</option>
                                    <option value="4">4 Hours</option>
                                    <option value="5">5 Hours</option>
                                </select>
                            </div>
                            <div class="col-6">
                                <select class="form-control" name="minutes" id="minutes" v-model="minutes">
                                    <option value="" selected>Minutes</option>
                                    <option value="0">0 Minutes</option>
                                    <option value="5">5 Minutes</option>
                                    <option value="10">10 Minutes</option>
                                    <option value="15">15 Minutes</option>
                                    <option value="20">20 Minutes</option>
                                    <option value="25">25 Minutes</option>
                                    <option value="30">30 Minutes</option>
                                    <option value="35">35 Minutes</option>
                                    <option value="40">40 Minutes</option>
                                    <option value="45">45 Minutes</option>
                                    <option value="50">50 Minutes</option>
                                    <option value="55">55 Minutes</option>
                                </select>
                            </div>
                        </div>
                        <error-message v-if="hasError('hours') || hasError('minutes')" :errors="[].concat(error.hours, error.minutes)"></error-message>
                    </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                    <label for="">Please select all areas that apply for this activity:</label>
                        <error-message v-if="hasError('areas')" :errors="error.areas"></error-message>
                        <div  v-show="areaOptions.length == 0" class="alert">Loading types...</div>
                        <div class="row" v-show="areaOptions.length > 0">
                            <div class="col">
                                <div class="form-check" v-for="area in areaOptions" :key="area.id" v-if="area.id % 2 == 0">
                                    <input class="form-check-input" type="checkbox" v-bind:id="'area-' + area.id" name="areas[]" v-bind:value="area.id" v-model="areas">
                                    <label class="form-check-label" v-bind:for="'area-' + area.id">{{area.name}}</label>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-check" v-for="area in areaOptions" :key="area.id" v-if="area.id % 2 !== 0">
                                    <input class="form-check-input" type="checkbox" v-bind:id="'area-' + area.id" name="areas[]" v-bind:value="area.id" v-model="areas">
                                    <label class="form-check-label" v-bind:for="'area-' + area.id">{{area.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div v-show="areas.indexOf(15) > -1">
                            <label for="areas-other-detail">Please specify other step/content</label>
                            <input id="areas-other-detail" type="text" v-model="areas_other_details" class="form-control">
                            <error-message v-if="hasError('areas_other_details')" :errors="error.areas_other_details"></error-message>                    
                        </div>
                        <div class="row" v-if="areas.includes('14') || areas.includes(14)">
                            <div class="col">
                                <label for="staffTrained">Number of Staff Trained</label>
                                <input type="number" class="form-control" name="staffTrained" id="staffTrained" v-model="staffTrained"/>
                                <error-message v-if="hasError('staff_trained')" :errors="error.staff_trained"></error-message>
                            </div>
                            <div class="col">
                                <label for="parentsTrained">Number of Parents Trained</label>
                                <input type="number" class="form-control" name="parentsTrained" id="parentsTrained" v-model="parentsTrained"/>
                                <error-message v-if="hasError('parents_trained')" :errors="error.parents_trained"></error-message>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label for="notes">Notes:</label>
                        <textarea name="notes" id="notes" rows='3' class="form-control" v-model="notes"></textarea>
                        <error-message v-if="hasError('notes')" :errors="error.notes"></error-message>
                    </div>
                </div>
                </form>
                <br />
                <div class="text-left">
                    <button type="button" class="btn btn-orange-blue" v-on:click="validate" :disabled="submitting">
                        {{submitting ? 'Saving...' : 'Save'}}
                    </button>
                </div>
            </div> 
            </div> 
        </div> 
    </BModal>        
</template>

<script>
    import ErrorMessage from '../ErrorMessage'
    import moment from 'moment'
    import BootstrapDatePicker from '../BootstrapDatePicker'
    
    export default {
        components: {
            ErrorMessage,
            BootstrapDatePicker
        },
        props: {
            log: {
                type: Object
            },
            title: {
                type: String,
                default: 'Add'
            },
            logAreas: {
                type: Array,
                default: () => {
                    return []
                }
            },
            types: {
                type: Array,
                default: () => {
                    return []
                }
            },
            program: {
                required: true,
                type: Object
            },
            value: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                areas: [],
                areas_other_details: null,
                type: "",
                date: null,
                hours: "",
                minutes: "",
                programId: null, 
                notes: null,
                staffTrained: null,
                parentsTrained: null,
                errors: [],
                showModal: false,
                areaOptions: [],
                typeOptions: [],
                submitting: false,
            }
        },
        watch: {
            log: function (to, from) {
                if (to !== from && to !== null) {
                    this.setupEditForm(to)
                }
            },
            showModal: function (to, from) {
                this.$emit('input', this.showModal);
            },
            value: function (to, from) {
                this.showModal = JSON.parse(JSON.stringify(this.value));
            },
        },
        methods: {
            hide () {
                this.showModal = false;
            },
            show () {
                this.showModal = true;
            },
        	validate: function(e){
        		this.errors = [];
                this.submit();
        	},
        	submit(){
                if(this.log){
                    var url = '/api/activity-log/edit/'+this.log.id
                }else{
                    var url = '/api/activity-log/store'
                }
                let data = {
        			type: this.type,
        			date: this.date,
        			hours: this.hours,
        			minutes: this.minutes,
        			areas: this.areas,
        			program_id : this.program.id,
                    notes: this.notes,
                    areas_other_details: this.areas_other_details
                }
                
                if (this.areas.indexOf(14) > -1) {
                    data.staff_trained = this.staffTrained
                    data.parents_trained = this.parentsTrained
                }

                this.submitting = true;
        		axios.post(url, data)
                    .then(response => {
                        this.submitting = false;
                        this.$emit('savedlog');
                        this.clearForm()
                        this.hide()
                    })
                    .catch(error => {
                        this.submitting = false;
                        this.error = error.response.data.errors
                    })
            },
            hasError(field) {
                if (!this.error) {
                    return false;
                }
                return Object.keys(this.error).indexOf(field) > -1;
            },
            setupEditForm(log){
                this.log = log
                this.type = log.activity_log_type_id
                this.hours = Math.round(log.time_spent / 60)
                this.minutes = log.time_spent % 60
                this.date = moment(log.date).format('YYYY-MM-DD')
                this.notes = log.notes
                this.areas = log.areaIds
                this.parentsTrained = log.parents_trained
                this.staffTrained = log.staff_trained
                this.areas_other_details = log.areas_other_details
                this.modalTitle = "Edit"
            },
            clearForm(){
                this.type = ""
                this.hours = ""
                this.minutes = ""
                this.date = null
                this.notes = null
                this.areas = []
                this.staffTrained = 0
                this.parentsTrained = 0
                this.areas_other_details = null
                this.modalTitle = "Add"

                this.error = {};
            },
        },
        mounted() {
            this.showModal = JSON.parse(JSON.stringify(this.value))
            this.typeOptions = this.types;
            if (this.types.length == 0) {
                window.axios.get('/api/activity_log_types')
                    .then(response => {
                        this.typeOptions = response.data
                    }).catch(error => {
                        console.error(error);
                    })
            }
            this.areaOptions = this.areas;
            if (this.logAreas.length == 0) {
                window.axios.get('/api/activity_log_areas')
                    .then(response => {
                        this.areaOptions = response.data
                    }).catch(error => {
                        console.error(error);
                    })
            }
        }
    
}
</script>